module.exports = __webpack_public_path__ + "static/media/fb2.d5c1227c.png";